/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Grid } from '@mui/material';

import Tabs, { Tab } from '../../../../components/Tabs';
import BigNumbers from './components/BigNumbers';

import Clients from './components/Clients';
import Period from './components/Period';
import Comparative from './components/Comparative';

import './styles.css';
import { Col, Wrapper } from './styles';
import { connect } from 'react-redux';

const Historic = ({ periodListFetching, comparativeFetching }) => {
  const [indexTab, setIndexTab] = useState(0);
  const [shouldReloadFilters] = useState(false);

  const _renderDashboardDetails = () => {
    switch (indexTab) {
      case 0:
        return <Period />;
      case 1:
        return <Comparative />;
      case 2:
        return <Clients />;
      default:
        break;
    }
  };

  const _handleChangeTab = index => {
    setIndexTab(index);
  };

  const isLoading = periodListFetching && comparativeFetching;

  return (
    <Wrapper>
      <Grid padding={2}>
        <BigNumbers />
      </Grid>
      <Grid item xs={6} md={12}>
      {
        !isLoading ?
          <Tabs classic fill className="DashboardCompleted__details-tabs">
            <Tab onClick={() => _handleChangeTab(0)} isActive={indexTab === 0}>
              Período
            </Tab>
            <Tab onClick={() => _handleChangeTab(1)} isActive={indexTab === 1}>
              Localidade
            </Tab>
            <Tab onClick={() => _handleChangeTab(2)} isActive={indexTab === 2}>
              Cliente
            </Tab>
          </Tabs>
        : null
      }
        <Col md12 className="DashboardCompleted__details-content">
          {_renderDashboardDetails()}
        </Col> 
      </Grid> 
    </Wrapper>
  );
};

const mapStateToProps = state => ({
  periodListFetching: state.dashboardCompleted.periodList.isFetching,
  comparativeFetching: state.dashboardCompleted.comparative.isFetching,
});

export default connect(mapStateToProps)(Historic);
